"use client";
import { Animated } from "../animated";
import { Banner } from "./banner";
import { TheChallenge } from "./the-challenge";
import { HowItWorks } from "./how-it-works";
import { HorizontalScroll } from "./horizontal-scroll";
import { OurTechnology } from "./our-technology";
import { CTA } from "./cta";
import { RealWorldSolutionsSection } from "./real-world-solutions";
import { SectionSeparator } from "../shared";

export default function NswWaterCompliance() {
  return (
    <Animated>
      <Banner />
      <TheChallenge />
      <SectionSeparator
        imageUrl="/images/nrar.webp"
        dataSpeed="0.1"
        imageClassName="mt-100"
      />
      <HowItWorks />
      <div className="bg-haizea-dark overflow-hidden">
        <HorizontalScroll />
        <OurTechnology />
      </div>
      <SectionSeparator
        imageUrl="/images/nrar-dashboard-charts.webp"
        dataSpeed="0.1"
        imageClassName="mt-100"
      />
      <RealWorldSolutionsSection />
      <CTA />
    </Animated>
  );
}
